export default __webpack_public_path__ + "static/webjet-79c746e0fd5b1802b4c90ba6cba0990d.webp";